import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EquipmentTypeService } from '@app/api/equipmentType.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'meu-modal-manage-brands',
  templateUrl: './modal-manage-brands.component.html',
  styleUrls: ['../modal-equipment-type/modal-equipment-type.component.scss'],
})
export class ModalManageBrandsComponent implements OnInit {
  loading: boolean = true;
  removing: boolean = false;
  equipmentType: any = null;
  brands: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ModalManageBrandsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string; name: string },
    private equipmentTypeService: EquipmentTypeService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadDetail();
  }

  loadDetail() {
    this.loading = true;
    this.equipmentTypeService.apiEquipmentTypesIdGet(this.data.id).subscribe((res) => {
      this.loading = false;
      if (res.success) {
        this.equipmentType = res.data;
        this.brands = res.data.brands || [];
        if (res.data.equipment_type_brands && Array.isArray(res.data.equipment_type_brands)) {
          const mappingMap: { [key: string]: string } = {};
          res.data.equipment_type_brands.forEach((etb: any) => {
            if (etb.brand_id) {
              mappingMap[etb.brand_id] = etb.id;
            }
          });
          this.brands = this.brands.map((b: any) => {
            var copy = Object.assign({}, b);
            copy.mapping_id = mappingMap[b.id] || b.equipment_type_brand_id || null;
            return copy;
          });
        }
        this.cdr.detectChanges();
      } else {
        this.toastr.error(res.message || 'Không thể tải dữ liệu');
      }
    }, () => {
      this.loading = false;
      this.cdr.detectChanges();
    });
  }

  removeBrand(brand: any) {
    if (!brand.mapping_id) {
      this.toastr.error('Không tìm thấy ID mapping để xóa');
      return;
    }
    this.removing = true;
    this.equipmentTypeService.apiEquipmentTypeBrandsIdDelete(brand.mapping_id).subscribe((res) => {
      this.removing = false;
      if (res.success) {
        this.toastr.success('Đã xóa hãng "' + brand.name + '" khỏi loại thiết bị');
        this.brands = this.brands.filter((b) => b.id !== brand.id);
        this.cdr.detectChanges();
      } else {
        this.toastr.error(res.message || 'Xóa hãng thất bại');
      }
    }, () => {
      this.removing = false;
      this.cdr.detectChanges();
    });
  }

  close() {
    this.dialogRef.close({ changed: true });
  }
}
